import React from 'react';
import { Bold, Minus } from 'lucide-react';

export const themaAnhaengen = (text, t) => {
  const basis = (text || '').replace(/\s+$/, '');
  const trenner = /^## /m.test(basis) ? '\n\n---\n' : (basis ? '\n\n' : '');
  return `${basis}${trenner}## ${t}\n`;
};

export const NotizAnzeige = ({ text, testId, klein = false }) => {
  if (!text) return <span className="text-[#9AA5B1]">—</span>;
  return (
    <div className={`${klein ? 'text-[13px]' : 'text-[14.5px]'} text-[#15202B] leading-relaxed`} data-testid={testId}>
      {text.split('\n').map((z, i) => (z.trim() === '---' ? <hr key={i} className="my-2 border-t border-[#B8893D]/50" />
        : z.startsWith('## ') ? <p key={i} className="font-bold text-[#1B3A5C] mt-1.5">{z.slice(3)}</p>
          : <p key={i} className="whitespace-pre-wrap min-h-[1em]">{z}</p>))}
    </div>
  );
};

const zeileGrenzen = (v, a, e) => [v.lastIndexOf('\n', a - 1) + 1, (v.indexOf('\n', e) + 1 || v.length + 1) - 1];

export const NotizWerkzeuge = ({ taRef, value, onChange, testId = 'notiz', klasse = '' }) => {
  const setzen = (neu, pos) => { onChange(neu); requestAnimationFrame(() => { const el = taRef.current; if (el) { el.focus(); el.setSelectionRange(pos[0], pos[1]); } }); };
  const fett = () => {
    const el = taRef.current; if (!el) return;
    const [s, e] = zeileGrenzen(value, el.selectionStart, el.selectionEnd);
    const zeilen = value.slice(s, e).split('\n');
    const frei = (z) => !z.trim() || z.trim() === '---';
    const alleFett = zeilen.every((z) => z.startsWith('## ') || frei(z));
    const neu = zeilen.map((z) => (frei(z) ? z : alleFett ? z.replace(/^## /, '') : (z.startsWith('## ') ? z : `## ${z}`))).join('\n');
    setzen(value.slice(0, s) + neu + value.slice(e), [s, s + neu.length]);
  };
  const linie = () => {
    const el = taRef.current; const pos = el ? el.selectionEnd : value.length;
    const vor = value.slice(0, pos).replace(/[ \t]+$/, ''); const nach = value.slice(pos);
    const kopf = `${vor}${vor && !vor.endsWith('\n') ? '\n' : ''}---\n`;
    const rest = nach.replace(/^\n/, '');
    setzen(`${kopf}${rest ? `\n${rest}` : ''}`, [kopf.length, kopf.length]);
  };
  const btn = `h-8 px-2.5 rounded-lg border border-[#DCE3EA] bg-white text-[12.5px] font-semibold text-[#15202B] inline-flex items-center gap-1 hover:border-[#B8893D]/60 transition-colors ${klasse}`;
  return (<>
    <button type="button" onClick={fett} className={btn} title="Zeile als Ankerpunkt fett markieren (oder Markierung aufheben)" data-testid={`${testId}-fett`}><Bold className="w-3.5 h-3.5" />Fett</button>
    <button type="button" onClick={linie} className={btn} title="Trennlinie an der Cursorstelle einfügen" data-testid={`${testId}-linie`}><Minus className="w-3.5 h-3.5" />Trennlinie</button>
  </>);
};
